import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Card,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Row,
  Col,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { DOG_LISTING_URL } from "../../../constants/ApiPaths";
import API from "../../../redux/actions/API";
import {
  getAuthAgencyId,
  getCustomerUserId,
} from "../../common/CommonFunctions";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import BackButtonSvg from "../../common/BackButtonSvg";
import { useDispatch } from "react-redux";
import ChoosePlanBox from "./ChoosePlanCommon/ChoosePlanBox";
import { getChoosePlan } from "../../../redux/actions";
import HeaderLogo from "../../common/HeaderLogo";
import { Info } from "../../common/Info";
import { ALL_DOG } from "../../../redux/actions/ActionTypes";
import { authCustomerHeader } from "../../../functions/CoreFunctions";
import dogImg from "../../../images/dog.png";

function CreateNewLicense() {
  const [loading, setLoading] = useState(false);
  const [dogName, setDogname] = useState("Select Pet");
  const [DogId, setDogId] = useState("");
  const dispatch = useDispatch();
  const history = useNavigate();
  const [DogDetails, setDogDetails] = useState([]);
  const dipatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const back = () => {
    history(-1);
  };

  let GetDog = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: DOG_LISTING_URL,
      headers: authCustomerHeader(),
      params: {
        userId: getCustomerUserId(),
        agencyId: getAuthAgencyId(),
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        dispatch({ type: ALL_DOG, payload: data });
        setDogDetails(data);
      }
    } catch (error) {
      if (error.response) {
        console.log(error)
      }
    } finally {
      setLoading(false);
    }
  };

  const dogOnChange = (e) => {
    const { dogid } = e.currentTarget.dataset;
    const dogname = e.currentTarget.textContent;
    setDogId(dogid);
    setDogname(dogname);
  };

  useEffect(() => {
    GetDog();
    dipatch(getChoosePlan());
  }, []);

  return (
    <div>
      {loading && <CustomPageLoading />}

      <HeaderLogo />

      <Container>
        <div className="page-title">
          <h4>
            New License{" "}
            <Tooltip
              isOpen={id === "newlicense" && tooltipOpen}
              target={"newlicense"}
              toggle={() => tooltiptoggle("newlicense")}
            >
              Create new license
            </Tooltip>
            <span id={"newlicense"}>
              <Info />
            </span>
          </h4>

          <div className="top-btn">
            <Button onClick={back} color="primary">
              {" "}
              <BackButtonSvg />
              Back
            </Button>
          </div>
        </div>

        <Card body className="mt-4">
          <Row>
            <Col sm="12" md={{ size: 6, offset: 3 }}>
              <div className="create-step">
                <h4>
                  Choose Your Pet{" "}
                  <Tooltip
                    isOpen={id === "chosoepet" && tooltipOpen}
                    target={"chosoepet"}
                    toggle={() => tooltiptoggle("chosoepet")}
                  >
                    Choose from the registered pets on customer account that you
                    want to license
                  </Tooltip>
                  <span id={"chosoepet"}>
                    <Info />
                  </span>
                </h4>
                {DogDetails === 0 ? (
                  <p style={{ color: "red", textAlign: "center" }}>
                    Please add your pet to proceed with licence
                  </p>
                ) : (
                  <center>
                    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                      <DropdownToggle caret>{dogName}</DropdownToggle>
                      <DropdownMenu>
                        {DogDetails.map((name) => (
                          <DropdownItem
                            onClick={dogOnChange}
                            data-dogId={name.dogId}
                            data-dogName={name.dogName}
                            style={{ marginBottom: "3px" }}
                          >
                            <img
                            alt=""
                              src={name.dogImageUrl ? name.dogImageUrl : dogImg}
                              style={{
                                border: "2px solid #10264f",
                                borderRadius: "50%",
                                width: "50px",
                                height: "50px",
                              }}
                            />{" "}
                            {name.dogName}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </center>
                )}
                <br />
              </div>
            </Col>
          </Row>

          <div className="create-step">
            <h4>
              Choose Plan{" "}
              <Tooltip
                isOpen={id === "chooseplans" && tooltipOpen}
                target={"chooseplans"}
                toggle={() => tooltiptoggle("chooseplans")}
              >
                Choose license type for registered pet
              </Tooltip>
              <span id={"chooseplans"}>
                <Info />
              </span>
            </h4>
          </div>
          <ChoosePlanBox DogId={DogId} />
        </Card>
      </Container>
    </div>
  );
}

export default CreateNewLicense;
